import { TFunction } from "@impero-com/common/utils/i18n";
import { assertNever } from "@impero-com/common/utils/obj";

import {
    EntitiesAccessRightsUpdateChange,
    EntitiesAccessRightsUpdateScope,
    StandardAccessRight,
} from "api/generated/model";
import { formatAccessRightRole } from "utils/accessRights";

export type AccessRightOption = StandardAccessRight | "NoAccess";

export const ACCESS_RIGHT_OPTIONS: AccessRightOption[] = [
    StandardAccessRight.Admin,
    StandardAccessRight.Edit,
    StandardAccessRight.View,
    "NoAccess",
];

export function toChange(
    option: AccessRightOption
): EntitiesAccessRightsUpdateChange {
    return option === "NoAccess"
        ? { type: "revoke" }
        : { type: "grant", right: option };
}

export function accessRightLabel(t: TFunction, option: AccessRightOption) {
    return option === "NoAccess"
        ? t("ControlEntities_AssignUsers_Right_NoAccess")
        : formatAccessRightRole(option);
}

export function scopeLabel(
    t: TFunction,
    scope: EntitiesAccessRightsUpdateScope
) {
    switch (scope) {
        case "control":
            return t("ControlEntities_AssignUsers_Scope_Control");
        case "risk":
            return t("ControlEntities_AssignUsers_Scope_Risk");
        case "both":
            return t("ControlEntities_AssignUsers_Scope_Both");
        default:
            return assertNever(scope);
    }
}
